/* USERS */
export const GET_CARRIERS = "GET_CARRIERS"
export const GET_CARRIERS_SUCCESS = "GET_CARRIERS_SUCCESS"
export const GET_CARRIERS_FAIL = "GET_CARRIERS_FAIL"

export const GET_CARRIERS_ALL_COMBO = "GET_CARRIERS_ALL_COMBO"
export const GET_CARRIERS_ALL_COMBO_SUCCESS = "GET_CARRIERS_ALL_COMBO_SUCCESS"
export const GET_CARRIERS_ALL_COMBO_FAIL = "GET_CARRIERS_ALL_COMBO_FAIL"

export const SAVE_USERS = "SAVE_USERS"
export const SAVE_USERS_SUCCESS = "SAVE_USERS_SUCCESS"
export const SAVE_USERS_FAIL = "SAVE_USERS_FAIL"
